module.exports = __webpack_public_path__ + "img/shoucang@3x.b7c059f8.svg";